import React, { useEffect, useState } from "react";
import { postData } from "../../api";
import { PortfolioCard } from "./ap";
import "../actualportfolio/actualportfolio.css";
import {  getAllPortfolioProjects } from "../../utils/imageLoader";
import ProjectDetailsModal from "./ProjectDetailsModal";
import NoImage from "../../assets/images/no-image.png";

let imageUrl = "https://www.centillionsoftechhrm.com/api/v1/resources/portfolio/";
function ProtfolioList() {
  const [data, setData] = useState([]);
  const [filterKey, setFilterKey] = useState(".webapplicatioin");
  const [activetab, setActivetab] = useState(2);
  const [filteredData, setFilteredData] = useState([]);
  const [animationClass, setAnimationClass] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Get all projects (merged from portfolioData and local images)
    const projects = getAllPortfolioProjects();
    console.log('projects', projects);
    setData(projects);
  }, []);

  // useEffect(() => {
  //   const get = async () => {
  //     const url = `${process.env.REACT_APP_BASEURL}/admin/portfolio/get`;
  //     const result = await postData(url, {});
  //     setData(result.data.data);
  //   };
  //   get();
  // }, []);
  useEffect(() => {
    setAnimationClass("fade-exit");
    setTimeout(() => {
      let filtered = data;
      if (filterKey === ".webapplicatioin") {
        filtered = data.filter(item => item.Section === "WEB" || item.Section ==="WEBSITE");
      } else if (filterKey === ".webdevlopment") {
        filtered = data.filter(item => item.Section === "APP");
      } else if (filterKey === ".reports") {
        filtered = data.filter(item => item.Section === "REPORTS");
      } 
      else if (filterKey === ".automation") {
        filtered = data.filter(item => item.Section === "AUTOMATION");
      }
      else if (filterKey === ".cloud") {
        filtered = data.filter(item => item.Section === "CLOUD");
      }
      setFilteredData(filtered);
      setAnimationClass("fade-enter");
    }, 500);
  }, [data, filterKey]);

  const handleFilterKeyChange = (key) => () => {
    setFilterKey(key);
    if (key === "*") setActivetab(2);
    else if (key === ".webapplicatioin") setActivetab(2);
    else if (key === ".webdevlopment") setActivetab(3);
    else if (key === ".reports") setActivetab(4);
    else if (key === ".automation") setActivetab(5);
    else if (key === ".cloud") setActivetab(6);
  };

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setShowModal(true);
  };

  return (
    <>
      <div className="portfolio_area" id="portfolio">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mb-5">
                <span className="about-badge mb-3">Our Work</span>
                <h2 className="banner-title mb-3" style={{ fontSize: "3rem" }}>
                  Our Latest <span className="gradient-text">Masterpieces</span>
                </h2>
                <p className="about-description mx-auto" style={{ maxWidth: '700px' }}>
                  Explore our diverse portfolio of high-performance web applications, 
                  innovative mobile solutions, and data-driven insights.
                </p>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul className="portfolio-filter shadow-sm">
                <li
                  className={activetab === 2 ? "active" : ""}
                  onClick={handleFilterKeyChange(".webapplicatioin")}
                >
                  Web Apps
                </li>
                <li
                  className={activetab === 3 ? "active" : ""}
                  onClick={handleFilterKeyChange(".webdevlopment")}
                >
                  App Dev
                </li>
                <li
                  className={activetab === 4 ? "active" : ""}
                  onClick={handleFilterKeyChange(".reports")}
                >
                  Reports & BI
                </li>
                <li
                  className={activetab === 6 ? "active" : ""}
                  onClick={handleFilterKeyChange(".cloud")}
                >
                  Cloud
                </li>
              </ul>
            </div>
          </div>

          <div className="row g-4">
            {filteredData.map((x, i) => (
              <div className={`col-xl-4 col-lg-6 col-md-6 ${animationClass}`} key={i}>
                <PortfolioCard
                  technology={x.technology}
                  src={x.localImageSrc}
                  title={x.projectName}
                  shortDescription={x.shortDescription} 
                  Section={x.Section}
                  Url={x.reportsUrl}
                  onClick={() => handleProjectClick(x)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <ProjectDetailsModal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        project={selectedProject} 
      />
    </>
  );
}


export default ProtfolioList;
